import { useMutation } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { findDriverControllerEndpoint } from 'repositories/BerthApi/findDriverController/endpoint'
import type {
  FindDriverControllerData,
  FindDriverControllerParams,
  FindDriverControllerResponse,
} from 'repositories/BerthApi/findDriverController/type'

export type { FindDriverControllerData }

export function useFindDriverController() {
  return useMutation<FindDriverControllerData | null, unknown, FindDriverControllerParams>({
    mutationFn: async (params) => {
      const res = await fetcher<FindDriverControllerResponse>(
        findDriverControllerEndpoint(params.vehicleControllerEmail)
      )
      const data = res.data
      if (!data || !data.vehicleControllerId) return null
      return data
    },
  })
}
